import { useState } from 'react'
import { useRequestsContext } from '../context/requests/requestsProvider'
import { REQUESTS_ACTIONS } from '../context/requests/REQUESTS_ACTIONS'
import SponsorService from '../services/SponsorService'

export default function useRequestsActions() {
  const { requestsDispatch } = useRequestsContext()
  const [inProgress, setInProgress] = useState(false)

  async function getRequests() {
    try {
      requestsDispatch({
        type: REQUESTS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await SponsorService.getSponsorsRequests()

      requestsDispatch({
        type: REQUESTS_ACTIONS.SET_REQUESTS,
        payload: {
          requests: data.requests,
           pagination: {
            links: data.links,
            current_page: data.current_page,
            first_page: data.first_page,
            last_page: data.last_page,
          },
        },
      })
    } catch (error) {
      
    } finally {
      requestsDispatch({
        type: REQUESTS_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function changeSponsorRequestStatus(RequestId, newRequestStatus) {
    try {
      setInProgress(true)
      const { data } = await SponsorService.changeSponsorRequestStatus(
        RequestId,
        newRequestStatus,
      )
      await getRequests()
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }
  return { getRequests, changeSponsorRequestStatus, inProgress }
}
